import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { LaborResponseModel } from '@/types'

export const getLaborMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<LaborResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/labor`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
